import { useTranslations } from 'next-intl';
import {
  MyEquipmentLinkContent,
  MyEquipmentDrawerLinkImage
} from 'components/pcc-components';
import { CatHeading } from 'components/blocks-components';
import {
  SERIAL_MATCH_IMAGE_PARAMS,
  EQUIPMENT_IMAGE_PARAMS,
  WIDGET_IDENTIFIER
} from '../../constants';
import styles from './style.module.scss';
import cx from 'classnames';
import { getFamilyName } from 'services/equipment/utils';
import { SelectedEquipmentInfoEdit } from './selected-equipment-info-edit';

type SelectedEquipmentInfo = {
  currentEquipment: {
    seoUrl?: string;
    serialNumber: string;
    productId?: string;
    imageUrl?: string;
    imageURL?: string;
    equipmentFamily: string;
    model: string;
    partNumber?: string;
    name?: string;
    assetId?:string;
    assetName?:string
  };
  identifier?: string;
};

export const SelectedEquipmentInfo = ({
  currentEquipment,
  identifier
}: SelectedEquipmentInfo) => {
  const t = useTranslations();
  const isAnEquipmentToAdd = identifier === WIDGET_IDENTIFIER.ADD;
  const imageParams = isAnEquipmentToAdd
    ? SERIAL_MATCH_IMAGE_PARAMS
    : EQUIPMENT_IMAGE_PARAMS;

  const imageUrl = `${currentEquipment.imageURL || currentEquipment.imageUrl}${imageParams}`;

  const name = getFamilyName(
    currentEquipment.model,
    currentEquipment.name || currentEquipment.equipmentFamily
  );

  return (
    <MyEquipmentLinkContent
      classname={cx('d-flex mt-2', {
        'align-items-start': !isAnEquipmentToAdd,
        'align-items-center': isAnEquipmentToAdd
      })}
    >
      <MyEquipmentDrawerLinkImage
        classname={styles['img--border']}
        alt={`${currentEquipment.model} ${name}`}
        src={imageUrl}
      />
      <MyEquipmentLinkContent classname="ps-3">
        {isAnEquipmentToAdd ? (
          <>
            <CatHeading variant="footnote" aria-live="polite">
              {t('MEQ_SERIAL_MODEL_MESSAGE')}
            </CatHeading>
            <CatHeading variant={'title-sm'}>
              {`${currentEquipment.model} `} -
              <span className="text-capitalize">{name.toLowerCase()}</span>
            </CatHeading>
          </>
        ) : (
          <SelectedEquipmentInfoEdit currentEquipment={currentEquipment} />
        )}
      </MyEquipmentLinkContent>
    </MyEquipmentLinkContent>
  );
};
